import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import Layout from "../Layout";
import Table from "antd/lib/table";
import { Tooltip, DatePicker, Space, Breadcrumb } from 'antd';
import { Toaster } from 'react-hot-toast';
import { fetchAllVersiondata, fetchAllSupportdataByUser } from "../../Redux/Api/fetch.api";
import { getallversionsummary } from '../../Redux/Actions/VersionActions';
import Title from "../Title";
import searchIcon from "../../assets/images/search_icon.svg";
import whatsapp from "../../assets/images/whatsapp.png";
import SMS from "../../assets/images/sms.png";
import video_call from "../../assets/images/video_option.svg";
import call_icon from "../../assets/images/call_option.svg";
import email_icon from "../../assets/images/mail_option.svg";
import chat_icon from "../../assets/images/chat_option.svg";
import {
    PlayArrow as PlayArrowIcon,
    NewReleases as NewReleasesIcon,
    CheckCircle as CheckCircleIcon,
    Replay as ReplayIcon,
    BugReport as BugReportIcon,
    RocketLaunch as RocketLaunchIcon,
    Attachment as AttachmentIcon,
    HistoryEdu as HistoryEduIcon,
} from '@mui/icons-material';
import { useTranslation } from "react-i18next";

const UserSupports = () => {
    const { t } = useTranslation('version');
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedUserId = localStorage.getItem('UserId');
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;
    const [assignedtable, setAssignedTable] = useState([]);
    const [AttachmentSrc, setAttachmentSrc] = useState();
    const [supportAttachmentModal, setSupportAttachmentModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: parseInt(REACT_APP_DEFAULT_PAGESIZE || 50),
            total: 0,
            pageSizeOptions: ['50', '100'],
            showSizeChanger: true,
        }
    });

    const [roleId] = useState(null); // replace or connect if dynamic roleId logic is planned

    const showPagination = totalCount > options.pagination.pageSize;

    const getAllSupportdataByUser = () => {
        setLoading(true);
        const payload = {
            userId: parseInt(loggedUserId),
            pageNumber: 1,
            pageSize: options.pagination.pageSize
        }

        fetchAllSupportdataByUser(payload)
            .then(response => {
                setAssignedTable(response.data.data)

            })
            .catch(err => console.error("Error fetching data:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        getAllSupportdataByUser();
    }, []);

    const handleSupportLog = (supportId) => {
        history.push(`/LogDetails/${supportId}`);
    }

    const openWorkitemEdit = (id, supportid) => {
        // window.location.href = `/Workitem/Edit/${id}/${supportid}`;
        history.push(`/Workitem/Edit/${id}/${supportid}`);
    };

    const assignedcolumns = [
        {
            title: "Request ID",
            dataIndex: "supportId",
        },

        {
            title: "Case ID",
            key: "caseId",
            dataIndex: "workitemid",
            render: (workitemid, row, index) => (
                workitemid ? (
                    <div
                        className="sup-workItem-container"
                        onClick={() => openWorkitemEdit(workitemid, row.supportId)}
                        style={{ cursor: 'pointer' }}
                    >
                        <span className="sup-workItem-highlight">
                            {`#${workitemid}`}
                        </span>
                    </div>
                ) : null
            )
        },

        {
            title: "Company",
            dataIndex: "companyName",
        },

        {
            title: "Site",
            dataIndex: "siteName",
        },

        {
            title: "App",
            dataIndex: "appName",
        },

        {
            title: "Request Type",
            dataIndex: "RequestType",
            render: (value, item, index) =>
            (<>
                {
                    (<>
                        {item.requestType === 1 &&
                            <div className="centered-container ">
                                <Tooltip title="Requested for Audio call">
                                    <button className="request-button-css">
                                        <img src={call_icon} className="apply-img"></img></button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 0 &&
                            <div className="centered-container ">
                                <Tooltip title="Requested for Live Chat">
                                    <button className="request-button-css">
                                        <img src={chat_icon} className="apply-img"
                                        ></img></button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 2 &&
                            <div className="centered-container ">
                                <Tooltip title="Requested for Video Call">
                                    <button className="request-button-css">
                                        <img src={video_call} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 3 &&
                            <div className="centered-container">
                                <Tooltip title="Requested for Email">
                                    <button className="request-button-css"
                                    >
                                        <img src={email_icon} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>
                        }

                        {item.requestType === 4 &&
                            <div className="centered-container ">
                                <Tooltip title="Requested for Whatsapp">
                                    <button className="request-button-css"
                                    >
                                        <img src={whatsapp} className="apply-img"
                                        ></img></button>
                                </Tooltip>
                            </div>
                        }

                        {item.requestType === 5 &&
                            <div className="centered-container ">
                                <Tooltip title="Requested for SMS">
                                    <button className="request-button-css"
                                    >
                                        <img src={SMS} className="apply-img"
                                        ></img></button>
                                </Tooltip>
                            </div>
                        }

                    </>)
                }
            </>)
        },

        {
            title: "Description",
            dataIndex: "description",
            className: "description_support",
            render: (description) => <Tooltip title={description}>{description}</Tooltip>,
        },

        {
            title: "Requested By",
            dataIndex: "requestedBy",
            className: "name-wrap"
        },

        {
            title: "Request Date",
            dataIndex: "requestDate",
            className: "date-wrap",

        },

        {
            title: "Communicate By",
            dataIndex: "phoneNumber",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {(record.requestType === 1 || record.requestType === 4 || record.requestType === 5) ?
                    <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">{record.phoneNumber}</div>
                    : (
                        record.emailId != "null" ? (
                            <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">
                                {record.emailId}
                            </div>
                        ) : ""
                    )}
            </>)
        },

        {
            title: t("Priority"),
            dataIndex: "priority",
            render: (value, item, index) =>
            (<>
                {item.priority == 1 ?
                    <div>
                        <span>High</span>
                    </div> :
                    item.priority == 2 ?
                        <div>
                            <span>Medium</span>
                        </div> :
                        <div>
                            <span>Low</span>
                        </div>
                }
            </>)
        },

        {
            title: "Assigned To",
            dataIndex: "assignedName",
            className: "name-wrap",
            render: (text, record, index) =>
            (<>
                {record.assignedDate && record.userId > 0 ? record.assignedName :
                    <div>
                        <span className="not-yet-assigned">{"Not yet assigned"}</span>
                    </div>
                }
            </>
            )
        },

        {
            title: "Assigned Date",
            dataIndex: "assignedDate",
            className: "date-wrap"
        },

        {
            title: "Start Date",
            dataIndex: "startDate",
            className: "date-wrap",
        },

        {
            title: t("Status"),
            dataIndex: "status",
            render: (value, item) => {
                if (item?.status === 3) {
                    return <span className="status-resolved">Closed</span>;
                } else if (item?.assignedDate && item?.userId > 0) {
                    return <span className="status-active">Active</span>;
                } else {
                    return <span className="status-new">New</span>;
                }
            }
        },

        {
            title: "Closed Date",
            dataIndex: "closedDate",
            className: "date-wrap"
        },

        {
            title: t("Log"),
            render: (record) => (
                record.supportId !== null && record.assignedDate != null ? (
                    <div className="support-log-btn">
                        <Tooltip title="Click to view Log">
                            <HistoryEduIcon
                                onClick={() => handleSupportLog(record.supportId)}
                                style={{ cursor: "pointer", color: "#000" }}
                            />
                        </Tooltip>
                    </div>
                ) : null
            )
        }
    ]

    return (
        <div>
            <Title title="Support Request" />
            <Layout>
                <section className="Company_section common">
                    <div className="container workitem-container">
                        <Toaster />
                        <Breadcrumb
                            itemRender={(route) => route.path ? <Link to={route.path}>{route.breadcrumbName}</Link> : <span>{route.breadcrumbName}</span>}
                            items={[
                                { breadcrumbName: 'Dashboard', path: '/Dashboard' },
                                { breadcrumbName: 'Support', path: '' },
                                { breadcrumbName: 'Support Logs', path: '' },
                            ]}
                        />

                        {/*<div className="report-header d-flex justify-content-between align-items-center mb-2">*/}
                        {/*    <div className="load-report">*/}
                        {/*        <div className="search-order-outer">*/}
                        {/*            <Space direction="vertical">*/}
                        {/*                <DatePicker*/}
                        {/*                    format="MM/DD/YYYY HH:mm:ss"*/}
                        {/*                    showTime*/}
                        {/*                    placeholder={t("SelectStartDateandTime")}*/}
                        {/*                    renderExtraFooter={() => (*/}
                        {/*                        <div className="timePickerHeader">*/}
                        {/*                            <div>Hr</div><div>Min</div><div>Sec</div>*/}
                        {/*                        </div>*/}
                        {/*                    )}*/}
                        {/*                />*/}
                        {/*            </Space>*/}

                        {/*            <Space direction="vertical">*/}
                        {/*                <DatePicker*/}
                        {/*                    format="MM/DD/YYYY HH:mm:ss"*/}
                        {/*                    showTime*/}
                        {/*                    placeholder={t("SelectEndDateandTime")}*/}
                        {/*                    renderExtraFooter={() => (*/}
                        {/*                        <div className="timePickerHeader">*/}
                        {/*                            <div>Hr</div><div>Min</div><div>Sec</div>*/}
                        {/*                        </div>*/}
                        {/*                    )}*/}
                        {/*                />*/}
                        {/*            </Space>*/}

                        {/*            <Tooltip title={t("Clicktosearchrequest")}>*/}
                        {/*                <button className="search-button-icon">*/}
                        {/*                    <img src={searchIcon} alt="Search" />*/}
                        {/*                </button>*/}
                        {/*            </Tooltip>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="Viewer-table index--table position-relative common-table mb-2">
                            <Table
                                className="table-responsive antd--detail-table1"
                                columns={assignedcolumns}
                                dataSource={assignedtable}
                                loading={loading}
                                pagination={showPagination ? {
                                    ...options.pagination,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
                                } : false}
                                onChange={(pagination) => {
                                    setOptions(prev => ({ ...prev, pagination }));
                                }}
                            />
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default UserSupports;
